import CarouselCard from "@components/core/cards/CarouselCard";
import InfoCard from "@components/core/cards/InfoCard";
import Section from "@components/core/section/Section";
import { AlertDetailResponseDto } from "@state/alerts/dto/response/alert.detail.response.dto";
import { ArticleDetailResponseDto } from "@state/cms/dto/response/article.detail.response.dto";
import { FunctionComponent } from "react";
import { useTranslation } from "react-i18next";

interface InfoCardsProps {
  alerts: AlertDetailResponseDto[];
  articles: ArticleDetailResponseDto[];
  className?: string;
  selectedOfficeIds: string[];
}

const InfoCards: FunctionComponent<InfoCardsProps> = ({
  alerts,
  articles,
  className = "",
  selectedOfficeIds,
}) => {
  const { t } = useTranslation();

  const alertList = alerts
    .filter((alert) => alert.type === "alert")
    .filter((alert) =>
      selectedOfficeIds.some((officeId) => officeId === alert.officeId),
    );
  const infoList = alerts
    .filter((alert) => alert.type === "info")
    .filter((alert) =>
      selectedOfficeIds.some((officeId) => officeId === alert.officeId),
    );

  return (
    <Section className={`app-info-cards ${className}`}>
      <div className="cards-container">
        <InfoCard
          title={`${t("home.alerts")} ${alertList.length}`}
          background="tertiary"
          color="white"
          list={alertList}
        />
        <InfoCard
          title={`${t("home.informations")} ${infoList.length}`}
          list={infoList}
          className="mt-0"
        />
        <CarouselCard articles={articles} />
      </div>
    </Section>
  );
};

export default InfoCards;
